<p-toast data-testid="business-unit-toast"></p-toast>
<p-confirmDialog
  data-testid="business-unit-unlink-confirm-dialog"
  styleClass="business-unit-unlink-confirm-dialog"
></p-confirmDialog>
<div
  data-testid="business-unit-page"
  class="roles-container pt-4 px-4 flex flex-col min-h-0 flex-1"
>
  <div class="p-2 flex-shrink-0">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "configuration.business_unit.management.title" | translate }}
    </h2>
  </div>

      <div class="flex main-container flex-1 min-h-0">
        <div class="flex-left">
          <app-business-unit-tree
            data-testid="business-unit-tree-panel"
            [units]="businessUnits()"
            [loading]="treeLoading()"
            [selectedUnitId]="selectedUnitId()"
            [expandedUnits]="expandedUnits()"
            [canUpdate]="canUpdate()"
            (unitSelect)="onUnitSelect($event)"
            (expandedUnitsChange)="onExpandedUnitsChange($event)"
            (assignStore)="onAssignStore()"
            (unlinkChannel)="onUnlinkChannel($event)"
            (syncDone)="loadBusinessUnits()"
          ></app-business-unit-tree>
        </div>

        <div class="flex-right">
          <app-business-unit-management
            data-testid="business-unit-management-panel"
            [users]="users()"
            [selectedUnitId]="selectedUnitId()"
            [selectedUnitName]="selectedUnitName()"
            [usersLoading]="usersLoading()"
            [canAssignUsers]="canAssignUsers()"
            (userUnassigned)="onUserUnassigned()"
            (assignUser)="onAssignUser()"
            (userSearchChange)="onUserSearchChange($event)"
          ></app-business-unit-management>
        </div>
      </div>
</div>
